export default __webpack_public_path__ + "static/media/iconBadge.88afb698.svg";